"use client";

import { useEffect, useState } from "react";

export function useOnline(): boolean {
  // SSR-safe default: assume online so the offline UI doesn't flash during hydration.
  // The first effect tick syncs us to the real navigator.onLine value.
  const [online, setOnline] = useState(true);

  useEffect(() => {
    const sync = () => setOnline(navigator.onLine);
    sync();
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);

  return online;
}
